import api from './apiClient';

export const startSession = async (powerBiReportId) => {
  const response = await api.post('/Log/session/start', { powerBiReportId });
  return response.data.sessionId;
};

export const endSession = async (sessionId, durationSeconds) => {
  await api.post('/Log/session/end', { sessionId, durationSeconds });
};

export const logPage = async (sessionId, pageName, durationSeconds) => {
  await api.post('/Log/page', { sessionId, pageName, durationSeconds });
};